<template>
  <div class="forgot-password-page">
    <router-link class="log-in-link" to="logIn"> Log In </router-link>
    <form class="inner-block" novalidate @submit.prevent="submit">
      <div>
        <h1>Forgot Your Password?</h1>
        <p>
          Please verify your email for us. Once you do, we'll send instructions
          to reset your password.
        </p>
        <div
          :class="{
            'form-group-error': $v.email.$error,
            'form-group': true,
            email: true,
          }"
        >
          <input
            id="email"
            v-model.trim="$v.email.$model"
            type="text"
            :disabled="isLoading"
            placeholder="Email"
            autocomplete="email"
            @change="onFieldChange($v.email)"
          />
          <div v-if="!$v.email.required" class="error">Email is required</div>
          <div v-if="!$v.email.email" class="error">
            Email must be a valid email address
          </div>
        </div>

        <alert v-if="error">
          {{ error }}
        </alert>
      </div>
      <cta-button
        type="submit"
        class="button"
        :loading="isLoading"
        :solid="true"
        >Reset my password</cta-button
      >
    </form>
    <reset-password-modal
      v-if="hasConfirmation"
      @close="confirmationComplete"
    />
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import env from "@/env";

import CtaButton from "@/components/CtaButton";
import Alert from "@/components/Alert";
import ResetPasswordModal from "@/components/ResetPasswordModal";

export default {
  name: "ForgotPasswordPage",
  mixins: [validationMixin],
  components: {
    CtaButton,
    Alert,
    ResetPasswordModal,
  },
  data() {
    return {
      email: null,
      isLoading: false,
      error: null,
      hasConfirmation: false,
      remoteUrl: env.getEnvVar("VUE_APP_REMOTE_URL"),
    };
  },
  validations: {
    email: { required, email },
  },
  methods: {
    submit() {
      this.error = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.error =
          "There was a problem with your submission. Please correct the errors in the form above.";
        return;
      }
      this.isLoading = true;
      this.$user
        .resetPassword(this.email)
        .then(this.passwordReset)
        .catch(this.handleError);
    },
    passwordReset() {
      this.isLoading = false;
      this.hasConfirmation = true;
    },
    handleError(err) {
      this.isLoading = false;
      if (err.response?.status === 422 && err.response?.data?.errors?.length) {
        if (err.response?.data?.errors?.indexOf("Email not found") > -1) {
          this.error =
            "We didn't find an account with the email you entered. Please try again.";
        } else {
          this.error = err.response?.data?.errors[0];
        }
      } else {
        this.error =
          "There was a problem resetting your password. Please try again.";
      }
    },
    confirmationComplete() {
      this.hasConfirmation = false;
      this.$router.push({ name: "logIn" });
    },
    onFieldChange(field) {
      this.error = null;
      if (field) {
        field.$touch();
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/style/mixins";
@import "@/style/variables.scss";

.forgot-password-page {
  position: relative;

  .log-in-link {
    position: absolute;
    right: 25px;
    top: -47px;
    font-size: 13.5px;
    font-weight: 700;
  }

  p {
    line-height: 30px;
    color: $lighter-black;
  }
}
</style>
